import { LoadingSpinnerCombinedProps } from './types';

const usePresenter = (props: LoadingSpinnerCombinedProps): LoadingSpinnerCombinedProps => {
  return props;
};

export default usePresenter;
